/* ==========================================================================
   Cart Rewards - collapse the reward cards while the cart list is scrolled
   --------------------------------------------------------------------------
   The reward cards sit ABOVE the drawer's scrolling item list rather than
   inside it, so they never scroll away. Good for visibility, but on a phone
   the two cards were taking about 300px of a ~680px drawer, leaving very
   little room for the products themselves.

   Once the customer scrolls the item list we mark the stack collapsed and
   assets/cart-rewards.css + assets/cart-tier.css fold each card down to a
   single line - message and progress bar only. Scrolling back to the top
   restores them. The CSS applies the collapse on small screens only; a
   desktop drawer has the room, and folding cards away under someone's cursor
   would just be startling.

   Deliberately standalone and dependency-free:

   - One capture-phase scroll listener on the document. Scroll events don't
     bubble, but they DO capture, so this survives the theme re-rendering the
     drawer wholesale on every cart update - which it does, and which would
     defeat a listener bound directly to the scrolling element.
   - No reliance on CartRewardsCore, so load order doesn't matter.
   - If anything is missing it simply does nothing, and the cards behave
     exactly as they did before.
   ========================================================================== */
(function () {
  'use strict';

  var COLLAPSE_AT = 24; /* px of scroll before the cards fold */
  var ATTR = 'data-cart-rewards-collapsed';
  var DRAWER_SELECTOR = 'cart-drawer, .cart-drawer, .drawer--cart, #CartDrawer';

  var pending = false;
  var queued = null;

  function apply() {
    pending = false;
    var job = queued;
    queued = null;
    if (!job || !job.stack || !job.stack.isConnected) return;
    job.stack.setAttribute(ATTR, job.scroller.scrollTop > COLLAPSE_AT ? 'true' : 'false');
  }

  function schedule(stack, scroller) {
    queued = { stack: stack, scroller: scroller };
    if (pending) return;
    pending = true;
    if (window.requestAnimationFrame) window.requestAnimationFrame(apply);
    else setTimeout(apply, 60);
  }

  function onScroll(event) {
    var scroller = event.target;
    if (!scroller || scroller.nodeType !== 1 || !scroller.closest) return;

    /* Only the cart drawer. The page itself scrolling is not our business. */
    var drawer = scroller.closest(DRAWER_SELECTOR);
    if (!drawer) return;

    var stack = drawer.querySelector('.cart-rewards-stack');
    if (!stack) return;

    schedule(stack, scroller);
  }

  /* Capture phase is the whole trick - see the note at the top of the file. */
  try {
    document.addEventListener('scroll', onScroll, { capture: true, passive: true });
  } catch (e) {
    /* Older browsers without options-object support. */
    document.addEventListener('scroll', onScroll, true);
  }

  /* A freshly re-rendered drawer starts at scrollTop 0, so clear any stale
     collapsed state rather than leaving the cards folded with nothing
     scrolled. Cheap, and only runs when the theme swaps the drawer out. */
  document.addEventListener('shopify:section:load', function () {
    var stacks = document.querySelectorAll('.cart-rewards-stack[' + ATTR + "='true']");
    for (var i = 0; i < stacks.length; i++) stacks[i].setAttribute(ATTR, 'false');
  });
})();